"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _ThumbnailUrlConfig = _interopRequireDefault(require("customer-data-email/schema/attachments/ThumbnailUrlConfig"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _Attachment = _interopRequireDefault(require("customer-data-email/components/attachments/Attachment"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _classnames = _interopRequireDefault(require("classnames"));

var propTypes = {
  attachments: _reactImmutableProptypes.default.listOf(_reactImmutableProptypes.default.map).isRequired,
  attachmentsInProgress: _reactImmutableProptypes.default.listOf(_reactImmutableProptypes.default.map),
  canView: _react.PropTypes.bool.isRequired,
  childClassName: _react.PropTypes.string,
  hasInteractions: _react.PropTypes.bool.isRequired,
  inline: _react.PropTypes.bool.isRequired,
  onAttachmentRemoved: _react.PropTypes.func,
  optionRemoveWithModal: _react.PropTypes.bool,
  thumbnailUrlConfig: _react.PropTypes.instanceOf(_ThumbnailUrlConfig.default).isRequired,
  useDefaultPadding: _react.PropTypes.bool
};
var defaultProps = {
  canView: true,
  hasInteractions: false,
  inline: true,
  useDefaultPadding: true,
  optionRemoveWithModal: false
};

var AttachmentsList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(AttachmentsList, _PureComponent);

  function AttachmentsList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AttachmentsList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AttachmentsList).call(this, props));
    _this.renderAttachment = _this.renderAttachment.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AttachmentsList, [{
    key: "renderAttachment",
    value: function renderAttachment(attachment) {
      var _this$props = this.props,
          onAttachmentRemoved = _this$props.onAttachmentRemoved,
          optionRemoveWithModal = _this$props.optionRemoveWithModal,
          hasInteractions = _this$props.hasInteractions,
          canView = _this$props.canView,
          thumbnailUrlConfig = _this$props.thumbnailUrlConfig;
      return _react.default.createElement(_Attachment.default, {
        attachment: attachment,
        canView: canView,
        hasInteractions: hasInteractions,
        key: attachment.get('name'),
        optionRemoveWithModal: optionRemoveWithModal,
        onRemoved: onAttachmentRemoved,
        thumbnailUrlConfig: thumbnailUrlConfig
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          attachments = _this$props2.attachments,
          attachmentsInProgress = _this$props2.attachmentsInProgress,
          inline = _this$props2.inline,
          useDefaultPadding = _this$props2.useDefaultPadding,
          childClassName = _this$props2.childClassName;
      var childClassNames = (0, _classnames.default)(childClassName, 'm-bottom-1 m-right-1');
      return _react.default.createElement(_UIList.default, {
        className: (0, _classnames.default)('p-bottom-2', {
          'p-left-1 p-y-2': useDefaultPadding
        }),
        childClassName: childClassNames,
        inline: inline
      }, attachments.map(this.renderAttachment), attachmentsInProgress && attachmentsInProgress.map(this.renderAttachment));
    }
  }]);
  return AttachmentsList;
}(_PureComponent2.default);

AttachmentsList.propTypes = propTypes;
AttachmentsList.defaultProps = defaultProps;
var _default = AttachmentsList;
exports.default = _default;
module.exports = exports.default;